import React from 'react';
import Offcanvas from "react-bootstrap/Offcanvas";

interface PropData {
    isShow: boolean;
    isClose: any;
    data: string;
}

const TasklistImagePreview = (props: PropData) => {

    const onCloseModal = (e?: any) => {
        props.isClose(!props.isShow, e)
    };

    return (
        <>
            <Offcanvas
                show={props.isShow}
                onHide={onCloseModal}
                placement={"end"}
                className="offcanvas-large"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Preview
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="border-bottom px-0 information-main-view d-flex align-items-center justify-content-center">
                    <img src={props.data} style={{ height: '50%', width: '50%' }} className='preview-image'/>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default TasklistImagePreview;